import React, {Component} from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import CelesteMap from "./components/CelesteMap/CelesteMap";
import SwitchLayers from "./components/SwitchLayers/SwitchLayers";
import AutoComplete from "./components/AutoComplete/AutoComplete";
import StepCeleste from "./components/StepCeleste/StepCeleste";
import ConfirmAddress from "./components/ConfirmAddress/ConfirmAddress";
import ResultAddress from "./components/ResultAddress/ResultAddress";
import MdDialog from "./components/MdDialog/MdDialog";
import dataLegend from "./dataLegend";
import CelesteMenu from "./components/Menu/CelesteMenu";

import ReactGA from 'react-ga';
import FormContact from "./components/FormContact/FormContact";
import CelesteGeolocateControl from "./components/CelesteMap/CelesteGeolocateControl";
import {memoriserOrigineDeLInternaute} from "./services/api";

const cartoURL = process.env.REACT_APP_CARTO_URL;
const GATrackine = process.env.REACT_APP_GA_TRACKING_ID;


const AppContainer = styled.div`
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const LoaderContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  position: absolute;
  z-index: 1000;
`;

const AutocompleteContainer = styled.div`
  position: absolute;
  height: auto;
  top: 0px;
  left: 0px;
  z-index: 20;
  @media only screen and (min-width: 768px) {
    top: 15px;
    left: 15px;
  }
`;

const LayersContainer = styled.div`
  position: absolute;
  height: auto;
  bottom: 0px;
  left: 0px;
  z-index: 10;
  @media only screen and (min-width: 615px) {
    position: fixed;
    width: 100vw;
  }
  @media only screen and (min-width: 768px) {
    width: 18em;
    margin-top: 7em;
    bottom: auto;
    top: 0px;
    left: 15px;
  }
`;

class App extends Component {
    constructor(props) {
        super(props);
        this.handleHelpDialog = this.handleHelpDialog.bind(this);

        this.state = {
            initLocation: false,
            currentAddressValue: null,
            confirmedAddress: null,
            geojson: null,
            sourcesAreLoaded: false,
            openModalResult: false,
            openFormContact: false,
            openModalAddress: false,
            initialPosition: null,
            clickPosition: null,
            currentDynamicLegend: null,
            showDynamicLegend: false,
            showHelp: false,
            searchValue: null,
            menuOpen: false,
            sessionApi: null
        };
    }

    componentDidMount() {
        fetch(`${cartoURL}/config.json`)
            .then(resp => resp.json())
            .then(geojson => {
                const currentDynamicLegend = dataLegend.find(
                    l => l.id === "fibre_dediee"
                );

                dataLegend.forEach(l => {
                    const layer = geojson.layers.find(layer => layer.id === l.id);
                    if (layer) {
                        l.color = layer.color;
                        l.title = layer.name;
                    }
                });

                this.setState({
                    geojson,
                    currentDynamicLegend,
                    showDynamicLegend: Boolean(currentDynamicLegend)
                });
            })
            .catch(error => {
                this.setState({geojson: {}});
            });


        ReactGA.initialize(GATrackine);
        ReactGA.pageview('/');

        memoriserOrigineDeLInternaute().then(informationsDeLinternaute => {
            this.setState({sessionApi: informationsDeLinternaute.session});
        });


    }

    handleLayerVisibility = (layerId, visibility) => {
        const geojson = JSON.parse(JSON.stringify(this.state.geojson));

        geojson.layers.find(layer => layer.id === layerId).visibility = visibility;

        if (visibility) {
            const currentDynamicLegend = this.getDynamicLegend(layerId);
            this.setState({
                geojson,
                currentDynamicLegend,
                showDynamicLegend: Boolean(currentDynamicLegend)
            });
        } else {
            if (
                this.state.currentDynamicLegend &&
                this.state.currentDynamicLegend.id === layerId
            ) {
                this.setState({geojson, showDynamicLegend: false});
            }
            this.setState({geojson});
        }
    };

    getInitialPosition = () => {
        if (this.state.forceRelocate) {
            this.geolocateUser();
        } else if (this.state.confirmedAddress) {
            return this.state.confirmedAddress.position;
        } else if (this.state.searchValue) {
            return this.state.searchValue;
        } else if (!this.state.initialPosition) {
            this.geolocateUser();
        }

        return this.state.initialPosition;
    };

    geolocateUser = () => {
        navigator.geolocation.getCurrentPosition((location) => {

            const position = {
                lat: location.coords.latitude,
                lon: location.coords.longitude
            };

            this.setState({
                initialPosition: position,
                forceRelocate: false,
                confirmedAddress: null,
                searchValue: null,
            });
        });
    };

    handleResetPosition = () => {
        this.setState({
            initialPosition: null,
            forceRelocate: true,
        });
    };

    handleAreSourcesLoaded = sourcesAreLoaded => {
        this.setState({sourcesAreLoaded});
    };

    OpenModalAddress = value => {
        this.setState({openModalAddress: true, searchValue: value, initialPosition: value});
    };

    closeModalAddress = currentAddressValue => {
        if (currentAddressValue === null) {
            this.resetSearch();
            this.setState({
                openModalAddress: false,
                openModalResult: false,
                currentAddressValue: null,
                confirmedAddress: null,
                searchValue: null
            });
        } else if (currentAddressValue) {
            this.setState({
                currentAddressValue: `${currentAddressValue.rue} ${
                    currentAddressValue.ville
                    }`,
                openModalAddress: false,
                confirmedAddress: currentAddressValue
            });

            this.OpenModalResult(currentAddressValue);

        } else {
            this.setState({
                openModalAddress: false,
                openModalResult: Boolean(currentAddressValue)
            });
        }
    };

    OpenModalResult = confirmedAddress => {

        if (this.state.currentAddressValue !== null || confirmedAddress != null) {
            this.setState({openModalResult: true});
        } else if (this.state.searchValue !== null || this.getInitialPosition() !== null) {

            let position;
            if (this.state.searchValue === null) {
                position = this.getInitialPosition();

            } else {
                position = this.state.searchValue;
            }


            this.OpenModalAddress({
                lat: position.lat,
                lon: position.lon
            });
        }
    };

    closeModalResult = () => {
        this.setState({
            openModalResult: false,
            currentAddressValue: null,
            openModalAddress: false,
            confirmedAddress: null,
            searchValue: null
        });
    };

    geolocate = (position, address) => {
        this.setState({openModalAddress: true, searchValue: address, initialPosition: address});
    };

    onUserSelectAddress = address => {
        this.setState({
            currentAddressValue: address.label,
            confirmedAddress: address.data
        });
    };

    getDynamicLegend = id => {
        return dataLegend.find(l => l.id === id);
    };

    handleHelpDialog = () => {
        this.setState({showHelp: !this.state.showHelp});
    };

    handleSetPosition = (position) => {
        this.setState({
            searchValue: position,
            lastLocation: position,
        });
    };

    resetSearch = () => {
        this.setState({currentAddressValue: null, confirmedAddress: null});
    };

    toggleContactForm = () => {

        ReactGA.event({
            category: 'Eligibilite',
            action: 'Formulaire de contact',
        });

        this.setState({
            openModalResult: false,
            openFormContact: true,
        });
    };

    handleContactForm = () => {
        this.setState({openFormContact: !this.state.openFormContact});
    };

    toggleMenu = (open) => () => {
        this.setState({
            menuOpen: open,
        });
    };


    render() {
        const {
            geojson,
            sourcesAreLoaded,
            showHelp
        } = this.state;

        return (
            <AppContainer>
                {(!geojson || !sourcesAreLoaded) && (
                    <LoaderContainer>
                        <CircularProgress size={150}/>
                    </LoaderContainer>
                )}

                <CelesteMenu
                    helpAction={this.handleHelpDialog}
                    toggleMenuAction={this.toggleMenu}
                    open={this.state.menuOpen}
                />
                <AutocompleteContainer>
                    <AutoComplete
                        toggleMenuAction={this.toggleMenu}
                        geolocate={this.geolocate}
                        OpenModalAddress={this.OpenModalAddress}
                        currentAddressValue={this.state.currentAddressValue}
                        onUserSelectAddress={this.onUserSelectAddress}
                        resetSearch={this.resetSearch}
                    />
                </AutocompleteContainer>

                <LayersContainer>
                    <SwitchLayers
                        helpAction={this.handleHelpDialog}
                        handleLayerVisibility={this.handleLayerVisibility}
                        geojson={geojson}
                    />
                    <StepCeleste />
                </LayersContainer>

                <CelesteMap
                    handleAreSourcesLoaded={this.handleAreSourcesLoaded}
                    sourcesAreLoaded={sourcesAreLoaded}
                    geojson={geojson}
                    OpenModalAddress={this.OpenModalAddress}
                    OpenModalResult={this.OpenModalResult}
                    openAdress={this.state.openModalAddress}
                    getInitialPosition={this.getInitialPosition}
                    handleSetPosition={this.handleSetPosition}
                    openResult={this.state.openModalResult}
                    confirmedAddress={this.state.confirmedAddress}
                    resetSearch={this.resetSearch}
                />

                <CelesteGeolocateControl geolocateUser={this.handleResetPosition}/>

                <ConfirmAddress
                    open={this.state.openModalAddress}
                    onClose={this.closeModalAddress}
                    value={this.state.searchValue}
                />

                <ResultAddress
                    open={this.state.openModalResult}
                    onClose={this.closeModalResult}
                    openContactForm={this.toggleContactForm}
                    value={this.state.confirmedAddress}
                />

                <FormContact
                    open={this.state.openFormContact}
                    closeMe={this.handleContactForm}
                    sessionApi={this.state.sessionApi}
                />

                <MdDialog open={showHelp} closeMe={this.handleHelpDialog}/>

            </AppContainer>
        );
    }
}

export default App;
